jQuery(function($) {
    $doc = $(document);


    function headerSizes() {
        //height of header
        $('#masterhead').height($(window).height());
        //header content's margin
        var headerContHeight = $('#masterhead .carousel').height();
        var headerBlockHeight = $('#masterhead').height();
        if (headerBlockHeight < 555) {
            $('#masterhead').height(460)
        } else if (headerContHeight + 10 > headerBlockHeight) {
            headerBlockHeight = headerContHeight + 0 + 0
        }
        var headerContMargin = (headerBlockHeight - headerContHeight) / 3;
        if (headerContMargin < 0) {
            headerContMargin = 0;
            $('#masterhead').height(headerContHeight + 0);

        };
        $('#masterhead .carousel').css('marginTop', headerContMargin);

    }


    function formSubmit() {
        var $form = $doc.find('#form');
        var $message = $doc.find('#message');
        $form.on('submit', function(event) { 
            event.preventDefault();
            if (!formValidate()) return;
            $form.find('input[type="submit"]').prop('disabled', 'disabled');
            $.post($form.attr('action'), $form.serialize(), function(response) {
                if ('true' == response) {
                    $form.fadeOut(500, function() {
                        $message.fadeIn();
                    });
                    setTimeout(function() {
                        $('input[type="reset"]').click();
                    }, 5000);
                }
                $form.find('input[type="submit"]').removeProp('disabled');
                $form.find('input[type="submit"]').removeAttr('disabled');
            });
        });
        $form.on('reset', function() {
            $message.fadeOut(500, function() {
                $form.fadeIn();
            });
        });
        $('input[type="reset"]').on('click', function(event) {
            event.preventDefault();
            $form.get(0).reset();
        });
    }

    function formValidate() {

        var ret = true;

        var $form = $doc.find('#form');
        var $name = $form.find('input[name="name"]');
        var $email = $form.find('input[name="email"]');
        var $descr = $form.find('textarea[name="description"]');

        var email = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;

        if ($name.val() == '') {
            ret = false;
            $name.addClass('error');
            //$name.css( 'border-color', '#f04248' );
        } else {
            $name.removeClass('error');
        }

        if ($email.val() == '' || !email.test($email.val())) {
            ret = false;
            $email.addClass('error');
            //$email.css( 'border-color', '#f04248' );
        } else {
            $email.removeClass('error');
        }

        if ($descr.val() == '') {
            ret = false;
            $descr.addClass('error');
            //$descr.css( 'border-color', '#f04248' );
        } else {
            $descr.removeClass('error');
        }

        return ret;
    }

    $(function() {
        $(".vertical").jCarouselLite({
            vertical: true,
            mouseWheel: true,
            speed: 100,
            visible: 1,
            circular: false

        });
        $(".verticalall").jCarouselLite({
            vertical: true,
            mouseWheel: true,
            speed: 100,
            visible: 2,
            circular: false

        });
        $("#carousel-example-generic").carousel({
            interval: 4000,
            pause: false
        });
    });
    $(document).ready(function() {
        headerSizes();
        //formSubmit();
    });
    //$(window).resize(function() {
    //    headerSizes();
    //});
});